import { render } from "./Vehicle.vue?vue&type=template&id=425c7897"
import script from "./Vehicle.vue?vue&type=script&lang=js"
export * from "./Vehicle.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\s.arshad\\Documents\\GitHub\\link-portal\\link\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__